import React from 'react'
import { getPropertyByString } from '../../utils/object'

const withMemoByProps = (Component, propsToWatch) =>
  React.memo(Component, (props, nextProps) => {
    return propsToWatch.every(name => getPropertyByString(props, name) === getPropertyByString(nextProps, name))
  })

export default withMemoByProps
